// extracted by mini-css-extract-plugin
export default {"btn_logout":"LogoutBtn_btn_logout__hMqv-","icon_logout":"LogoutBtn_icon_logout__ylPrX"};